/**
 * @file 検索
 */
'use strict';

import Common from "../../Utils/Common";

/**
 * @classname TableSearch
 * @classdesc 検索
 */
export default class TableSearch {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-table-search')
	 */
	constructor($e, controller) {
		console.log('TableSearch.constructor');
		this._$e = $e;
		this._controller = controller
		this._$searchItemsWrap = this._$e.closest('#search-items-wrap')
		this._$dataValidateInSearch = this._$searchItemsWrap.find('[data-validate-in-search="true"]')
		$e.on('click', () => this.onClick());
		$('.profile-search, .user-board-search').on(('keypress'), e => this.onKeypress(e));
		if (this._$dataValidateInSearch.length) this._$dataValidateInSearch.each((idx, element) => $(element).on('blur change', () => this.validateSearchForm()))
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof TableSearch
	 * @return {undefined}
	 */
	onClick() {
		console.log('TableSearch.onClick');
		this._error = false
		this._validity = true
		this._validationErrorMessage = ''
		this.resetControllerState()
		let url = this._$e.hasClass('btn-user-board-search')
			? '/user/board'
			: Common.getCurrentURL()
		console.log(url);
		if (this._$dataValidateInSearch.length) this.validateSearchForm();
		if (this._validity) {
			let param = this._getSearchQuery();
			console.log(`${url}${param}`);
			if (!this._error) {
				this._controller._listener.trigger('clear-local-storage')
				location.href = `${url}${param}`
			};
		} else {
			Common.showErrorModal(`<p>検索条件の入力に誤りがあります。</p>${this._validationErrorMessage}`)
		}
	};


	/**
	 * keypressのコールバック
	 *
	 * @memberof EnterSubmit
	 * @return {undefined}
	 */
	onKeypress(e) {
		console.log('EnterSubmit.onKeypress');
		this._error = false
		const key = e.keyCode || e.charCode || 0;
		if (key === 13) {
			let url = this._$e.hasClass('btn-user-board-search')
				? '/user/board'
				: Common.getCurrentURL()
			console.log(url);
			let param = this._getSearchQuery();
			console.log(`${url}${param}`);
			if (!this._error) {
				this._controller._listener.trigger('clear-local-storage')
				location.href = `${url}${param}`
			};
		}
	};


	/**
	 * 検索GETパラメーター取得
	 *
	 * @memberof Table
	 * @return {string} query - 検索GETパラメーター
	 */
	_getSearchQuery() {
		console.log('Table._getSearchQuery');
		let prefix = '?';
		let query = '';
		let radioName;
		let errorNames = [];
		let multipleRequiredErrorNames = [];
		$('[data-search-item]').each((idx, e) => {
			const $e = $(e);
			if ($e.attr('data-search-type') === 'radio') {
				const name = $e.attr('name');
				if (radioName !== name) {
					const checked = $(`input[type=radio][name=${name}]:checked`);
					const value = checked.val();
					if (value !== 'all') {
						query += `${prefix}${$e.attr('data-search-item')}=${value}`;
						prefix = '&';
					}
					radioName = name;
					if (checked.attr('data-search-inside') === 'true' && value !== 'all') {
						this._open = true;
					}
				}
			} else if ($e.attr('data-search-type') === 'checkbox') {
				if ($e.prop('checked')) {
					const value = $e.val();
					query += `${prefix}${$e.attr('data-search-item')}=${value}`;
					prefix = '&';
					if ($e.attr('data-search-inside') === 'true') {
						this._open = true;
					}
				}
			} else if ($e.attr('data-search-type') === 'array_base') {
				const name = $e.attr('data-search-item');
				let value = '';
				value = $(`[data-search-item=${name}`).map((idx, e) => {
					const $e = $(e);
					if ($e.prop('checked')) return $e.val();
				}).get().join('|');
				if (value.length > 0) {
					query += `${prefix}${name}=${value}`;
					prefix = '&';
				}
			} else if ($e.attr('data-search-type') === 'array') {

			} else if ($e.attr('data-search-type') === 'multiple') {
				console.log($e.attr('id'));
				const name = $e.attr('data-search-item');
				let value = '';
				value = $e.find('option:selected').map((idx, e) => {
					return $(e).val();
				}).get().join('|');
				if (value.length > 0) {
					query += `${prefix}${name}=${value}`;
					prefix = '&';
				}
			} else {
				console.log('data-search-type is not set')
				if ($e.is(':invalid')) {
					console.log($e.attr('data-search-item') + ': ' + $e.is(':valid'));
					if ($e.prop('required')) errorNames.push($e.data('search-item-name'));
					this._error = true;
				}
				const $multipleRequiredElements = this._$searchItemsWrap.find('[data-search-multiple-required=true]')
				let multipleRequiredValidity = false
				if (!!$multipleRequiredElements.length) {
					$multipleRequiredElements.each((idx, element) => {
						console.log('in multipleRequiredValidity checking...')
						if ($(element).val() != '') multipleRequiredValidity = true
					})
					if (!multipleRequiredValidity) {
						this._error = true;
						$multipleRequiredElements.each((idx, element) => {
							multipleRequiredErrorNames.push($(element).data('search-multiple-required-name'))
						})					
					}
				}
				const value = encodeURIComponent($e.val());
				console.log(value);
				if (value !== '') {
					query += `${prefix}${$e.attr('data-search-item')}=${value}`;
					prefix = '&';
				}
			}
		});
		if(!!errorNames.length) {
			let message = ''
			errorNames.forEach((errorName, idx) => idx == 0 ? message += errorName : message += `、${errorName}`)
			Common.showErrorModal(`${message}は必須です。`)
		}
		if (!!multipleRequiredErrorNames.length) {
			let names = new Set(multipleRequiredErrorNames)
			Common.showErrorModal(`${Array.from(names).join('、')}のいずれかの入力は必須です。`)
		}
		return query;
	};


	/**
	 * 検索前のバリデーション
	 *
	 * @memberof Table
	 * @return {boolean} validity
	 */
	validateSearchForm() {
		console.log('Table.validateSearchForm')
		this._$dataValidateInSearch.each((idx, element) => {
			if (!$(element).attr('data-validate')) return
			const validations = $(element).attr('data-validate').split(' ')
			if ($(element).val() === '' && !validations.includes('birthday')) {
				$(element).removeClass('is-invalid')
				return
			}
			validations.forEach(validation => this[validation]($(element)))
		})
	}


	/**
	 * バリデーションメソッド: 加盟員No
	 * @memberof Table
	 */
	memberid($element) {
		console.log('Table.validations.memberid')
		const val = $element.val();
		const digit = parseInt(val.charAt(10));
		const even = parseInt(val.charAt(1)) + parseInt(val.charAt(3)) + parseInt(val.charAt(5)) + parseInt(val.charAt(7)) + parseInt(val.charAt(9));
		const odd = parseInt(val.charAt(0)) + parseInt(val.charAt(2)) + parseInt(val.charAt(4)) + parseInt(val.charAt(6)) + parseInt(val.charAt(8));
		let total = even * 3 + odd;
		total = new String(total);
		const totalLen = total.length;
		const last = parseInt(total.charAt(totalLen-1));
		let rest;
		if (last === 0){
			rest = 0;
		}else{
			rest = 10 - last;
		}
		console.log(`${digit} / ${rest}`);
		if (rest !== digit) {
			this._validity = false
			this._validationErrorMessage += '<p>加盟員Noの形式が正しくありません。</p>'
			$element.addClass('is-invalid')
		} else {
			$element.removeClass('is-invalid')
		}
	}


	/**
	 * バリデーションメソッド: 生年月日は年・月・日すべて入力されているときのみ検索可とする
	 * @memberof Table
	 */
	birthday($element) {
		console.log('Table.validations.birthday')
		if (this._controller._isCompletedYearValidation && this._controller._isCompletedMonthValidation && this._controller._isCompletedDayValidation) {
			this._controller._isCompletedYearValidation = false
			this._controller._isCompletedMonthValidation = false
			this._controller._isCompletedDayValidation = false
		}
		if ($element.hasClass('year')) this._controller._isCompletedYearValidation = true
		if ($element.hasClass('month')) this._controller._isCompletedMonthValidation = true
		if ($element.hasClass('day')) this._controller._isCompletedDayValidation = true
		const $year = $element.closest('.row').find('.year')
		const $month = $element.closest('.row').find('.month')
		const $day = $element.closest('.row').find('.day')
		console.log(`$year.val(): ${$year.val()} / $month.val(): ${$month.val()} / $day.val(): ${$day.val()}`)
		if (($year.val() !== '' || $month.val() !== '' || $day.val() !== '') && ($year.val() === '' || $month.val() === '' || $day.val() === '')) {
			this._validity = false
			Array.from([$year, $month, $day]).forEach((_$element) => {
				_$element.val() === '' ? _$element.addClass('is-invalid') : _$element.removeClass('is-invalid')
			})
			if (this._controller._isCompletedYearValidation && this._controller._isCompletedMonthValidation && this._controller._isCompletedDayValidation) this._validationErrorMessage += '<p>生年月日による検索は年月日すべて選択してください。</p>'
		} else {
			Array.from([$year, $month, $day]).forEach((_$element) => _$element.removeClass('is-invalid'))
		}
	}


	/**
	 * バリデーションメソッド: カタカナ
	 * @memberof Table
	 */
	katakana($element) {
		console.log('Table.validations.katakana')
		if (!$element.val().match(/^[ァ-ヾ０-９－\s　！”＃＄％＆’（）＝～｜‘｛＋＊｝＜＞？＿－＾￥＠「；：」、。・]+$/)) {
			this._validity = false
			$element.addClass('is-invalid')
			if (!this._controller._isKatakanaInvalid) this._validationErrorMessage += '<p>カナの項目は全角カタカナで入力してください。</p>'
			this._controller._isKatakanaInvalid = true
		} else {
			$element.removeClass('is-invalid')
		}
	}


	/**
	 * バリデーションメソッド: 電話番号
	 * @memberof Table
	 */
	tel($element) {
		console.log('Table.validations.tel')
		let validity = true
		// 数字チェック
		if (!$element.val().match(/^[0-9\s!"#\$%&'\(\)=~\|`{\+\*}<>\?_\-\^\\@\[;:\],\.\/\^]+$/)) {
			validity = false
			this._validity = false
		}
		// スペースチェック
		if ($element.val().match(/[　\s]/)) {
			validity = false
			this._validity = false
		}
		// 文字数チェック
		if ($element.val().length > 13 || $element.val().length < 10) {
			validity = false
			this._validity = false
		}
		if (!validity) {
			this._validationErrorMessage += '<p>電話番号は数字とハイフンのみの10〜13文字で入力してください。</p>'
			$element.addClass('is-invalid')
		} else {
			$element.removeClass('is-invalid')
		}
	}


	/**
	 * コントローラーで保持するバリデーション関連のstateをリセット
	 * @memberof Table
	 */
	resetControllerState() {
		console.log('Table.validations.resetControllerState')
		this._controller._isKatakanaInvalid = false
	}
}
